<template>
    <b-list-group role="tablist" class="shadow bg-white p-b rounded-0">
        <b-list-group-item
            v-for="(item, i) in menuFiltrado"
            :key="i"
            :to="{
                name: 'familias_edit',
                params: {
                    id: $route.params.id,
                    aba: item.slug,
                },
            }"
            :class="pageAtual == item.tab ? 'active' : ''"
            class="nav-link"
            role="tab"
        >
            {{ item.titulo }}
        </b-list-group-item>
    </b-list-group>
</template>

<script>
export default {
    props: {
        estadoCadastral: {
            required: false,
        },

        pageAtual: {
            type: String,
            default: "identificacao",
        },

        menu: {
            type: Array,
            required: true,
        },
    },

    computed: {
        menuFiltrado() {
            const roleName = this.$store.state.user.role_details.name;

            if (roleName != "Nível Básico") {
                return this.menu;
            }

            return this.menu.filter((item) => item.tab == "identificacao");
        },
    },
};
</script>